import http from "./HttpService";
var apiEndpoint = `system/user/guides/public-module`;

const axiosConfigs = {
  AlterBaseURL: false,
};


const getUserGuides = async (moduleName) => {
    const response = http.get(`${apiEndpoint}/${moduleName}`);
    return response;
  }

const uploadDocument = async (document, moduleName) => {
  var multiPartHeaders = {
    "Content-Type": "multipart/form-data",
  };

   const response = await http.post(`${apiEndpoint}/${moduleName}`, document,
      { headers: multiPartHeaders }
   );
  return  response;
};



const downloadFile = async (id) => {
   const response = await http.get(`${apiEndpoint}/download/${id}`,
   { responseType: 'arraybuffer' })
  //  { responseType: 'arraybuffer', ...axiosConfigs })
   return  response;
};

export default {
  uploadDocument,
  getUserGuides,
  downloadFile
};
